import React from 'react';
import { ProgressBar } from 'react-bootstrap';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { useRoutePath } from '~/hooks/useRoutePath';
import { useFormatPrice } from '~/utils/price';

interface FreeDeliveryProps {
  remainingAmount: number | null | undefined;
  currencyCode?: string;
  orderTotal: number | undefined;
  onLinkClick?: () => void;
  /** API flag: false once the cart holds an item free delivery does not apply to. */
  display?: boolean;
}

const FreeDelivery = ({ remainingAmount, currencyCode, orderTotal, onLinkClick, display }: FreeDeliveryProps) => {
  const formatPrice = useFormatPrice();
  const routePath = useRoutePath();
  const { t } = useTranslation();
  if (display === false) return null;
  if (!remainingAmount && remainingAmount !== 0) return null;

  const isFreeDelivery = remainingAmount <= 0;
  const freeDeliveryThreshold = remainingAmount + (orderTotal ?? 0);
  const percentage = isFreeDelivery
    ? 100
    : freeDeliveryThreshold > 0
      ? ((orderTotal ?? 0) / freeDeliveryThreshold) * 100
      : 0;

  return (
    <div className="free-delivery">
      <p className="free-delivery__label">
        {isFreeDelivery ? (
          <span>
            <Trans
              i18nKey="components.free_delivery.achieved"
              components={[<span className="free-delivery__highlight" />]}
            />
          </span>
        ) : (
          <span>
            <Trans
              i18nKey="components.free_delivery.label"
              values={{ amount: formatPrice(remainingAmount, currencyCode) }}
              components={[
                <Link
                  to={routePath('category', t('components.free_delivery.small_products_slug'))}
                  onClick={onLinkClick}
                  className="free-delivery__link"
                />,
                <strong />,
                <span className="free-delivery__highlight" />,
              ]}
            />
          </span>
        )}
      </p>
      <ProgressBar variant="success" now={percentage} />
    </div>
  );
};

export default FreeDelivery;
